module.exports = __webpack_public_path__ + "img/greyUpDirect.974a43b8.svg";